import { ClientType } from "../../model/client/clientType";
import { AbstractRestService } from "../abstractRestService";

export class ClientTypeService extends AbstractRestService<ClientType> {
  constructor() {
    super("/api/client-type");
  }
}
export const clientTypeService = new ClientTypeService();
